import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
import BlazeButton from '@blaze-react/button';
import { parseUrl } from 'query-string';
import { getItemList } from '../../../application/query';
import { useItemListId } from '../hooks';
import { getItemListData, setItemListId, setParamAndRedirect } from '../helpers';
import { LIST_ITEM_QUERY_PARAM } from '../constants';

const ItemListNew = ({ listName, modifier, text }) => {
  const router = useRouter();
  const { query: { [LIST_ITEM_QUERY_PARAM]: listItemId } = {} } = parseUrl(router.asPath);

  const { listId } = useItemListId({ listName });
  const listIdToUse = listItemId || listId;
  const { data, error, loading } = useQuery(getItemList, {
    variables: { id: listIdToUse },
    skip: !listIdToUse
  });

  if (loading) return '';
  if (error) return error.message;

  const listItems = getItemListData(data);
  if (!listItems.length) return '';

  const handleClick = () => {
    setItemListId(listName, '');
    setParamAndRedirect(router);
  };

  return (
    <BlazeButton
      className={`item-list-new ${modifier}`}
      onClick={handleClick}
      aria-label={`Create new ${listName}`}>
      {text}
    </BlazeButton>
  );
};

ItemListNew.propTypes = {
  listName: PropTypes.string.isRequired,
  modifier: PropTypes.string,
  text: PropTypes.string.isRequired
};

ItemListNew.defaultProps = {
  modifier: ''
};

export default ItemListNew;
